import React, { useContext } from 'react'
import { useSiteConfig, SettingsContext } from '../_hooks/useSiteConfig'

// Provider component
export function SettingsProvider({ children }: { children: React.ReactNode }) {
  const config = useSiteConfig()
  
  return (
    <SettingsContext.Provider value={config}>
      {children}
    </SettingsContext.Provider>
  )
}

// Hook to use the settings context
export function useSettings() {
  const context = useContext(SettingsContext)
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider')
  }
  return context
}